<template>
    <div>
        <div v-if="!block" id="captcha" ref="captcha"></div>
        <div v-else >
            <span class="nch-captcha-wait">
                {{$t('captcha.wait')}} <strong> {{ time }} </strong>
            </span>
        </div>
    </div>
</template>

<script>

    import { loadScript, loadLink } from '../../../../../resources/js/utils/Script'

    export default {
        name: 'Captcha',

        props: {
            imgPath: {
                type: String,
                default: '/img/',
            },
            numberOfImages: {
                type: Number,
                default: 5,
            },
            callbacks:  {
                type: Object,
            },
            retries: {
                type: Number,
                default: 4,
            }
        },

        data() {
            return {
                tries: 0,
                time: 15,
                settings: {
                    numberOfImages: this.numberOfImages,
                    callbacks: this.callbacks ? this.callbacks : {loaded: this.loaded},
                    loaded: this.loaded,
                    url: `//${location.host}/captcha`,
                },
                captcha: null,
            }
        },  

        computed: {
            language() {
                const keys = ['accessibilityAlt','accessibilityTitle','accessibilityDescription','explanation','refreshAlt','refreshTitle']

                return keys.reduce((translations, key) => {
                    translations[key] = this.$t(`captcha.frontend.${key}`);
                    return translations;
                }, {})
            },
            block() {
                return this.tries >= this.retries;
            }
        },

        async mounted() {

            this.$loading.show();
            const script = await loadScript('/lib/visualCaptcha/dist/visualcaptcha.vanilla.js');
            const style = await loadLink('/lib/visualCaptcha/dist/visualcaptcha.css', {async: true, rel: 'stylesheet'});
            
            script.addEventListener('load', (e) => {
                this.start();
            });
        },
        
        methods: {

            loaded(captcha) {
                this.captcha = captcha
                this.$loading.close();
            },

            start() {
                visualCaptcha('captcha', {
                    imgPath: this.imgPath,
                    language: this.language,
                    url: `//${location.host}/captcha`,
                    captcha: this.settings
                });

                const observer = new MutationObserver( this.getItemsCaptcha );
                observer.observe(this.$refs.captcha, {
                    childList: true
                });
            },

            getItemsCaptcha(){
                for(let i=0; i<this.numberOfImages; i++){
                    let itemCaptcha = document.querySelector(`#visualCaptcha-img-${i}`);
                    itemCaptcha.onclick = event => event.preventDefault();
                }
                document.querySelector(".visualCaptcha-refresh-button > a").onclick = event => event.preventDefault();
            },

            showTime() {
                const timer = setInterval(() => {
                    if(this.time > 0) {
                        this.time -= 1;
                    } else {
                        this.$loading.show();
                        this.tries = 0;
                        this.time = 30;
                        this.start();
                        clearInterval(timer);
                    }
                }, 1000)
            },

            async send() {

                this.$loading.show();
            
                const form = this.captcha.getCaptchaData();
                return new Promise((resolve)  => {

                    axios.post(`/captcha/send/${form.value}`)
                    .then(res => {
                        const { data } = res
                        if(data.type === 'success') {
                            resolve(true)
                            this.$loading.close();
                            this.start();
                        }
                            
                    }).catch(e => {
                        const { data } = e.response;
                        resolve(false);
                        this.$loading.close();
                        this.$notify({
                            message: data.message,
                            type: 'danger',
                        })
                        this.tries += 1;
                        if(this.block) {
                            this.showTime()
                        } else {
                            this.start();
                        }
                    });
                })

            }
        }
    }
</script>

<style scoped>
    .nch-captcha-wait{
        width: 100%;
        -webkit-border-radius:7px;
        -moz-border-radius:7px;
        border-radius:7px;
        background-color:#c1f7e8;
        padding:10px;
        text-align:center;
        font-family:Oxygen,sans-serif;
        font-size:18px;
        color:#219589;
        font-weight:100;
        margin:20px 0 24px;
        text-align: center;
    }
</style>
<style>
    .visualCaptcha-possibilities{
        display: flex !important;
        justify-content: space-around !important;
        margin: 0 !important;
        margin-bottom: 5px !important;
    }
    .visualCaptcha-button-group{
        display: flex !important;
        justify-content: space-around !important;
    }
    /** Audio: developing... */
    .visualCaptcha-accessibility-button{
        display: none !important;
    }
    .visualCaptcha{
        margin-bottom: 5px !important;
    }
</style>